export default "__VITE_ASSET__FdSHdeOr__"